import sectionImage from "../../../assets/homePageV2/results.png";
import { resultadoEsperadoContent as c } from "./content";
import { ReactComponent as BackIcon } from "../../../assets/svg/icons/back.svg";

export function Results() {
  return (
    <section
      className="home-page-v2__section home-page-v2__section--resultado"
      style={{
        backgroundImage: `url(${sectionImage})`,
        height: "100%",
        minHeight: 700,
        backgroundSize: "cover"
      }}
    >
      <div className="home-page-v2__section--resultado__subBanner" />
      <div className="home-page-v2__section-inner">
        <div className="home-page-v2__resultado-top">
          <div className="home-page-v2__resultado-description">
            <div className="home-page-v2__resultado-title">
              <span>{c.titlePart1}</span>
              <strong>{c.titlePart2}</strong>
            </div>

            <p>
              <strong>{c.bodyLead}</strong> {c.bodyRest}
            </p>
          </div>
          <ul className="pill-list pill-list--resultado">
            {c.benefits.map((text) => (
              <li key={text}>
                <div className="home-page-v2__pill-list-icon" aria-hidden>
                  <BackIcon width={20} height={20} />
                </div>
                <span>
                  {text}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
